import React from 'react';
import { withMediaClient } from '@atlaskit/media-client-react';
import MediaCardAnalyticsErrorBoundary from './media-card-analytics-error-boundary';
import { Card as InternalCard } from './card';
export var CardWithMediaClient = function CardWithMediaClient(props) {
  var dimensions = props.dimensions,
    onClick = props.onClick;
  var Card = React.useMemo(function () {
    return withMediaClient(InternalCard);
  }, []);
  return /*#__PURE__*/React.createElement(MediaCardAnalyticsErrorBoundary, {
    dimensions: dimensions,
    onClick: onClick
  }, /*#__PURE__*/React.createElement(Card, props));
};